import { render, staticRenderFns } from "./QContentPriority.vue?vue&type=template&id=fd1393d2&"
import script from "./QContentPriority.vue?vue&type=script&lang=js&"
export * from "./QContentPriority.vue?vue&type=script&lang=js&"
import style0 from "./QContentPriority.vue?vue&type=style&index=0&id=fd1393d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports